import React from 'react';
import { cn } from '../../utils/cn';

interface PageContentProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}

export const PageContent: React.FC<PageContentProps> = ({
  children,
  className,
  fullWidth = false,
}) => {
  if (fullWidth) {
    return <div className={cn('w-full relative', className)}>{children}</div>;
  }

  return (
    <div className={cn('w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 relative', className)}>
      {children}
    </div>
  );
};
